import { Injectable } from '@angular/core';
import { ProductCardService } from './product-card.service';
import { ListsOverlayService } from '@app/lists/services/lists-overlay.service';
import { ListDetailManagementService } from '@app/lists/shared/list-detail-management/services/list-detail-management.service';
import {
  ActionSheetController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState } from '@panamax/app-state';
import { ProductAlternativeSearchService } from '@product-detail/services/product-alternative-search.service';
import { ProductDetailTagsService } from '@product-detail/services/product-detail-tags.service';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { ModalService } from '../modal/modal.service';
import { ToggleNewSearchService } from '../toggle-new-search/toggle-new-search.service';
import { EllipsisClickData } from '@shared/models/usf-product-card.model';
import { PdpLnkSrc } from '@shared/constants/pdp-lnksrc.enum';

@Injectable({
  providedIn: 'root',
})
export class SellerShowcaseProductCardService extends ProductCardService {
  constructor(
    actionSheetController: ActionSheetController,
    modalController: ModalController,
    popoverController: PopoverController,
    panAppState: PanAppState,
    translateService: TranslateService,
    listsOverlayService: ListsOverlayService,
    modalService: ModalService,
    navigationHelperService: NavigationHelperService,
    productAlternativeSearchService: ProductAlternativeSearchService,
    productDetailTagsService: ProductDetailTagsService,
    listDetailManagementService: ListDetailManagementService,
    analyticsService: ProductAnalyticsService,
    toggleNewSearchService: ToggleNewSearchService,
  ) {
    super(
      actionSheetController,
      modalController,
      popoverController,
      panAppState,
      translateService,
      listsOverlayService,
      modalService,
      navigationHelperService,
      productAlternativeSearchService,
      productDetailTagsService,
      listDetailManagementService,
      analyticsService,
      toggleNewSearchService,
    );
  }

  constructEllipsisButtons(ellipsisClickData: EllipsisClickData) {
    let buttons = [];
    this.getSellerQuickViewBtn(buttons, ellipsisClickData);
    return buttons;
  }

  routeToPDP(productNumber: number, isQuickView: boolean, lnksrc?: PdpLnkSrc) {
    const linkSource = isQuickView ? PdpLnkSrc.quickView : lnksrc;
    if (linkSource) {
      this.navigationHelperService.routeToProductDetailsQueryParams(
        productNumber,
        { lnksrc: linkSource },
      );
    } else {
      this.navigationHelperService.routeToProductDetails(productNumber);
    }
  }
}
